import {
  FETCH_USER_ROLES_FAILED,
  FETCH_USER_ROLES_STARTED,
  FETCH_USER_ROLES_SUCCEEDED,
  VALIDATE_USER_FAILED,
  VALIDATE_USER_SUCCEEDED,
  VALIDATE_USER_STARTED,
  CANCEL_ROLE_MANAGEMENT,
  FETCH_GUIDELINE_ROLES_FAILED,
  FETCH_GUIDELINE_ROLES_SUCCEEDED,
  FETCH_GUIDELINE_ROLES_STARTED,
  ASSIGN_USER_ROLE_FAILED,
  ASSIGN_USER_ROLE_SUCCEEDED,
  ASSIGN_USER_ROLE_STARTED,
  REMOVE_USER_ROLE_FAILED,
  REMOVE_USER_ROLE_SUCCEEDED,
  REMOVE_USER_ROLE_STARTED,
} from '../action-types/userRolesActionTypes';

const initialState = {
  roles: [],
  userRoles: [],
  error: '',
  isLoading: false,
  validUser: false,
  requiredAction: -1,
  email: '',
};

const userRolesReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_USER_ROLES_STARTED: {
      return {
        ...state,
        isLoading: true,
      };
    }
    case FETCH_USER_ROLES_SUCCEEDED: {
      return {
        ...state,
        isLoading: false,
        userRoles: action.userRoles,
      };
    }
    case FETCH_USER_ROLES_FAILED: {
      return {
        ...initialState,
        err: action.err,
      };
    }

    case FETCH_GUIDELINE_ROLES_STARTED: {
      return {
        ...state,
        isLoading: true,
      };
    }
    case FETCH_GUIDELINE_ROLES_SUCCEEDED: {
      return {
        ...state,
        isLoading: false,
        roles: action.roles,
      };
    }
    case FETCH_GUIDELINE_ROLES_FAILED: {
      return {
        ...initialState,
        err: action.err,
      };
    }

    case VALIDATE_USER_STARTED: {
      return {
        ...state,
        isLoading: true,
      };
    }
    case VALIDATE_USER_SUCCEEDED: {
      return {
        ...state,
        isLoading: false,
        validUser: action.validUser,
        requiredAction: action.requiredAction,
        email: action.email,
      };
    }
    case VALIDATE_USER_FAILED: {
      return {
        ...initialState,
        err: action.err,
      };
    }

    case ASSIGN_USER_ROLE_STARTED: {
      return {
        ...state,
        isLoading: true,
      };
    }
    case ASSIGN_USER_ROLE_SUCCEEDED: {
      return {
        ...state,
        isLoading: false,
      };
    }
    case ASSIGN_USER_ROLE_FAILED: {
      return {
        ...state,
        err: action.err,
        isLoading: false,
      };
    }

    case REMOVE_USER_ROLE_STARTED: {
      return {
        ...state,
        isLoading: true,
      };
    }
    case REMOVE_USER_ROLE_SUCCEEDED: {
      return {
        ...state,
        isLoading: false,
      };
    }
    case REMOVE_USER_ROLE_FAILED: {
      return {
        ...state,
        err: action.err,
        isLoading: false,
      };
    }

    case CANCEL_ROLE_MANAGEMENT: {
      return {
        ...initialState,
      };
    }
    default: {
      return state;
    }
  }
};

export default userRolesReducer;
